import "./generated-1784537902.css";

const lessons = [
  ["1강: 함수의 극한", 100, "과제 제출 필요"],
  ["2강: 극한의 성질과 계산", 100, "과제 제출 필요"],
  ["3강: 극한의 성질과 계산", 100, "과제 제출 필요"],
  ["4강 : 도함수의 활용", 74, "시청 중"],
  ["5강 : 도함수의 그래프 활용", 0, ""],
  ["6강 : 부정적분 기초", 0, ""],
  ["7강 : 부정적분 기초", 0, ""],
  ["8강 : 정적분과 넓이", 0, ""],
] as const;

export default function Generated1784537902() {
  return <main className="lecture-page">
    <aside className="lecture-sidebar">
      <div className="lecture-logo">내신인강</div>
      <button className="semester">2학년 1학기 중간 <span>⌄</span></button>
      <nav>
        <button className="selected"><i>◆</i> 나의 학습</button>
        {[["과제",2],["직보자료",2],["질문",2],["선생님 공지",2],["알림",2],["마이페이지",2]].map(([label,count]) => <button key={label}>{label}<b>{count}</b></button>)}
      </nav>
    </aside>
    <section className="lecture-content">
      <header className="student-row">
        <div className="student"><span className="student-avatar"/><strong>이하은 학생</strong><small>이화여자 강남 세화고등학교</small></div>
        <button className="teacher">담당 : 한상우 선생님　⌄</button>
      </header>
      <section className="reward-row">
        <div className="streak-card"><div className="streak-medal">3</div><div><strong>연속 출석 3일 달성 <em>/////</em></strong><small>4일만 꾸준히 출석하면 위클리 엠블럼 획득가능</small></div></div>
        <div className="reward"><span className="gem green">3</span><div><strong>진도 보상</strong><small>3일 연속</small></div><b>›</b></div>
        <div className="reward"><span className="gem purple">3</span><div><strong>과제 보상</strong><small>3일 연속</small></div><b>›</b></div>
      </section>
      <h2>시험 정보</h2>
      <section className="exam-info"><div><small>부교재</small><strong>쎈 수학Ⅰ + 자이스토리</strong></div><div><small>시험 기간</small><strong>26.06.24 ~ 26.06.27</strong></div><div><small>시험 범위</small><strong>함수의 극한과 연속 ~ 도함수의 활용 (접선의 방정식 또는 평균값 정리까지)</strong></div></section>
      <h2>전체 학습 진도</h2>
      <section className="lesson-list">
        {lessons.map(([title, progress, badge], index) => <article className={`${progress === 0 ? "locked" : ""} ${progress === 74 ? "current" : ""}`} key={title}>
          <span className="lesson-number">{index + 1}</span>
          <div className="lesson-main"><strong>{title}</strong>{progress > 0 && <div className="progress"><i style={{width:`${progress}%`}}/><small>{progress}%</small></div>}</div>
          {progress > 0 && <div className="lesson-status"><small>업로드 대기</small><b>{badge}</b></div>}
        </article>)}
      </section>
    </section>
    <button className="chat">▱ 채팅하기</button>
  </main>;
}
